import { TableContainerComponent } from './table-container.component';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TableContainerHeaderComponent } from './components/table-container-header/table-container-header.component';
import { TableContainerBodyComponent } from './components/table-container-body/table-container-body.component';



@NgModule({
  declarations: [TableContainerComponent, TableContainerHeaderComponent, TableContainerBodyComponent],
  imports: [
    CommonModule
  ],
  exports: [TableContainerComponent, TableContainerHeaderComponent, TableContainerBodyComponent]
})
export class TableContainerModule { }
